function formataNumero(value) {
  return Intl.NumberFormat().format(value);
}

export default formataNumero;
